import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import ZoneService from "../../../../../services/ZoneService";
import PhoneInput from "react-phone-input-2";
import DriversService from "../../../../../services/DriversService";
import WorkShiftService from "../../../../../services/WorkShiftService";
import BaseService from "../../../../../services/BaseService";

const AddParkingSlotsModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		phone: "",
		email: "",
		password: "",
		zone: "",
		licence_number: "",
		licence_image: "",
		work_shift: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const [workShiftOptions, setWorkShiftOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const zoneService = new ZoneService();
	const driversService = new DriversService();
	const workShiftService = new WorkShiftService();

	useEffect(() => {
		Promise.all([zoneService?.getList(), workShiftService?.getList()]).then(
			(res) => {
				if (res[0]?.status === 200) {
					let data = res[0]?.data?.data?.data?.map((info) => {
						return {
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					setZonesOptions(data);
				}
				if (res[1]?.status === 200) {
					let data = res[1]?.data?.data?.data?.map((info) => {
						return {
							label: info?.name,
							value: info?.id,
						};
					});
					setWorkShiftOptions(data);
				}

				if (Object.keys(item)?.length === 0) {
					setIsAdd(true);
				} else {
					setIsAdd(false);
					setFormData({
						id: item?.id,
						name: item?.username,
						phone: item?.phone,
						email: item?.email,
						password: "",
						zone: {
							label: lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar,
							value: item?.zone?.id,
						},
						licence_number: item?.licence_number || "",
						licence_image: item?.licence_image || "",
						work_shift: {
							label: item?.work_shift?.name,
							value: item?.work_shift?.id,
						},
					});
				}
			}
		);
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.zone?.value || !formData?.work_shift?.value) {
			return;
		}
		let data = {
			username: formData?.name,
			phone: formData?.phone,
			email: formData?.email,
			zone_id: formData?.zone?.value,
			shift_id: formData?.work_shift?.value,
		};
		if (!!formData?.licence_image)
			data["license_image"] = formData?.licence_image;
		if (!!formData?.licence_number)
			data["license_number"] = formData?.licence_number;

		setLoading(true);
		if (isAdd) {
			data["password"] = formData?.password;
			driversService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			if (!!formData?.password) data["password"] = formData?.password;
			driversService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData({ ...formData, [name]: res.data.url });
			}
		});
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.driver}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* Name */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>

						{/* Phone */}
						<Col md={6} className="mb-3">
							<label>
								{Translate[lang]?.phone}
								<span className="star-require">*</span>
							</label>
							<PhoneInput
								country={"kw"}
								className="w-100"
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>

						{/* Email */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.email}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="email"
								placeholder={Translate[lang]?.email}
								bsSize="lg"
								name="email"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.email}
								onChange={(e) =>
									setFormData({
										...formData,
										email: e.target.value,
									})
								}
							/>
						</Col>
						{/* Password */}
						<Col md={6} className="position-relative">
							<label>
								{Translate[lang].password}
								<span className="star-require">*</span>
							</label>
							<AvField
								name="password2"
								type={showPassword ? "text" : "password"}
								value={formData?.password}
								className="radius-10 h-45"
								errorMessage="Please enter a valid password"
								validate={{
									required: {
										value: isAdd,
										errorMessage: Translate[lang].field_required,
									},
								}}
								placeholder={Translate[lang].password}
								onChange={(e) =>
									setFormData({ ...formData, password: e.target.value })
								}
							/>
							{showPassword ? (
								<i
									className="la la-eye-slash position-absolute cursor-pointer"
									style={{
										top: "44px",
										right: lang === "en" ? "8%" : "auto",
										left: lang === "ar" ? "8%" : "auto",
									}}
									onClick={() => setShowPassword(false)}></i>
							) : (
								<i
									className="la la-eye position-absolute cursor-pointer"
									style={{
										top: "44px",
										right: lang === "en" ? "8%" : "auto",
										left: lang === "ar" ? "8%" : "auto",
									}}
									onClick={() => setShowPassword(true)}></i>
							)}
						</Col>

						{/* Zone */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.zone}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) => setFormData({ ...formData, zone: e })}
							/>
						</Col>

						{/* licence Number */}
						<Col md={6}>
							<label>{Translate[lang]?.licence_number}</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.licence_number}
								bsSize="lg"
								name="licence_number"
								value={formData?.licence_number}
								onChange={(e) =>
									setFormData({
										...formData,
										licence_number: e.target.value,
									})
								}
							/>
						</Col>

						{/* licence image */}
						<Col md={6}>
							<label className="text-label mb-0">
								{Translate[lang].licence_image}
							</label>
							<div className="upload">
								<input
									type="file"
									name="licence_image"
									id="licence_image"
									onChange={(e) => fileHandler(e, "licence_image")}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.licence_image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.licence_image && (
								<img
									src={formData?.licence_image}
									alt="licence_image"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>

						{/* Work Shift */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.work_shift}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.work_shift}
								name="work_shift"
								placeholder={Translate[lang]?.select}
								options={workShiftOptions}
								onChange={(e) => setFormData({ ...formData, work_shift: e })}
							/>
						</Col>
					</Row>
					<Button
						variant="primary"
						type="submit"
						className="w-100 mt-3"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.driver}
					</Button>
				</Modal.Body>
			</AvForm>
		</Modal>
	);
};

export default AddParkingSlotsModal;
